var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { Box, Button, Card, CardActions, CardContent, List, ListItem, Typography } from "@mui/joy";
import { useRequest } from '../../../hooks/useRequest';
import { STRIPE_PUBLIC_KEY, STRIPE_BASIC_PRICE_ID, STRIPE_PRO_PRICE_ID } from "../../../constants";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
var stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
export var Upgrade = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var workspaceId = _a.workspaceId;
    var request = useRequest();
    var _k = useState(null), pricing = _k[0], setPricing = _k[1];
    var _l = useState(null), pricingV2 = _l[0], setPricingV2 = _l[1];
    var _m = useState(true), loadingPricing = _m[0], setLoadingPricing = _m[1];
    useEffect(function () {
        fetchPricing();
    }, [workspaceId]);
    var fetchPricing = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, v1Response, v2Response, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, Promise.all([
                            request.get("/payments/pay-as-you-go/pricing?workspaceId=".concat(workspaceId)),
                            request.get("/payments/v2/pay-as-you-go/pricing?workspaceId=".concat(workspaceId))
                        ])];
                case 1:
                    _a = _b.sent(), v1Response = _a[0], v2Response = _a[1];
                    setPricing(v1Response.data);
                    setPricingV2(v2Response.data);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _b.sent();
                    // Use defaults if fetching fails
                    setPricing({
                        directTransferPrice: 0.850000,
                        usedSecondPrice: 0.001834,
                        transferredSecondPrice: 0.000667,
                        outboundSecondPrice: 0.002168,
                        isPayAsYouGo: false,
                        isPayAsYouGoAllowed: false
                    });
                    setPricingV2({
                        baseVoiceEnginePricePerMinute: 0.07,
                        outboundAddonPricePerMinute: 0.01,
                        directTransferPrice: 0.85,
                        transferredSecondsPricePerMinute: 0.04,
                        discountPercentage: 0
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setLoadingPricing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onUpgrade = function (priceId) { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, response, session, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, stripePromise];
                case 1:
                    stripe = _a.sent();
                    return [4 /*yield*/, request.post('/payments/checkout/session', { priceId: priceId, workspaceId: workspaceId })];
                case 2:
                    response = _a.sent();
                    session = response.data;
                    return [4 /*yield*/, (stripe === null || stripe === void 0 ? void 0 : stripe.redirectToCheckout({
                            sessionId: session.sessionId,
                        }))];
                case 3:
                    result = _a.sent();
                    if (result === null || result === void 0 ? void 0 : result.error) {
                        console.error(result.error.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onPayAsYouGoUpgrade = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, response, session, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, stripePromise];
                case 1:
                    stripe = _a.sent();
                    return [4 /*yield*/, request.post('/payments/pay-as-you-go/checkout/session', {
                            workspaceId: workspaceId,
                            directTransferPrice: pricing.directTransferPrice,
                            usedSecondPrice: pricing.usedSecondPrice,
                            transferredSecondPrice: pricing.transferredSecondPrice,
                            outboundSecondPrice: pricing.outboundSecondPrice // Use second-based pricing
                        })];
                case 2:
                    response = _a.sent();
                    session = response.data;
                    return [4 /*yield*/, (stripe === null || stripe === void 0 ? void 0 : stripe.redirectToCheckout({
                            sessionId: session.sessionId,
                        }))];
                case 3:
                    result = _a.sent();
                    if (result === null || result === void 0 ? void 0 : result.error) {
                        console.error(result.error.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onPayAsYouGoV2Upgrade = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, response, session, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, stripePromise];
                case 1:
                    stripe = _a.sent();
                    return [4 /*yield*/, request.post('/payments/v2/pay-as-you-go/checkout/session', {
                            workspaceId: workspaceId,
                            discountPercentage: pricing.discountPercentage || 0
                        })];
                case 2:
                    response = _a.sent();
                    session = response.data;
                    return [4 /*yield*/, (stripe === null || stripe === void 0 ? void 0 : stripe.redirectToCheckout({
                            sessionId: session.sessionId,
                        }))];
                case 3:
                    result = _a.sent();
                    if (result === null || result === void 0 ? void 0 : result.error) {
                        console.error(result.error.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var PricingOption = function (_a) {
        var priceId = _a.priceId, title = _a.title, description = _a.description, price = _a.price, messages = _a.messages, minutes = _a.minutes, features = _a.features, recommended = _a.recommended, selected = _a.selected;
        return (_jsxs(Card, __assign({ variant: "outlined", sx: {
                borderColor: selected ? '#007FFF' : '#ddd',
                boxShadow: selected ? '0 0 10px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.3s ease',
                minWidth: 250
            } }, { children: [_jsxs(CardContent, { children: [_jsx(Typography, __assign({ level: "h2" }, { children: title })), _jsxs(Typography, __assign({ level: "title-lg", sx: { mb: 0.5 } }, { children: ["$", price, _jsx(Typography, __assign({ level: "title-md" }, { children: "/month" }))] })), _jsx(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 0.5 } }, { children: description })), messages > 0 && _jsxs(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 0.5 } }, { children: [messages, " messages included"] })), minutes > 0 && _jsxs(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 0.5 } }, { children: [minutes, " minutes included"] })), _jsx(List, { children: features.map(function (feature, index) { return (_jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [feature.included ? (_jsx(CheckIcon, { color: "success", sx: { mr: 1 } })) : (_jsx(CloseIcon, { color: "error", sx: { mr: 1 } })), _jsx(Typography, { children: feature.name })] }), index)); }) })] }), _jsx(CardActions, { children: _jsx(Button, __assign({ variant: recommended ? "solid" : "outlined", disabled: selected, color: "primary", onClick: function () { return onUpgrade(priceId); } }, { children: selected ? 'Current Plan' : 'Upgrade' })) })] })));
    };
    var pricingOptions = [
        {
            priceId: STRIPE_BASIC_PRICE_ID,
            title: 'Basic',
            description: 'For small businesses',
            price: 49,
            messages: 1000,
            minutes: 0,
            features: [
                { name: 'Chat', included: true },
                { name: 'HubSpot Integration', included: true },
                { name: 'Analytics', included: true }
            ],
            recommended: false,
            selected: false
        },
        {
            priceId: STRIPE_PRO_PRICE_ID,
            title: 'Pro',
            description: 'Everyting in Basic +',
            price: 499,
            messages: 0,
            minutes: 2500,
            features: [
                { name: 'Voice', included: true },
                { name: 'SIP', included: true },
                { name: 'Twilio', included: true },
                { name: 'Auto Training', included: true }
            ],
            recommended: true,
            selected: false
        }
    ];
    return (_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-around', alignItems: 'center', gap: 2, flexWrap: 'wrap' } }, { children: [pricingOptions.map(function (option) { return (_jsx(PricingOption, { priceId: option.priceId, title: option.title, description: option.description, price: option.price, messages: option.messages, minutes: option.minutes, features: option.features, recommended: option.recommended, selected: option.selected }, option.priceId)); }), (!loadingPricing && (pricing === null || pricing === void 0 ? void 0 : pricing.isPayAsYouGoAllowed)) && (_jsxs(Card, __assign({ variant: "outlined", sx: {
                    borderColor: '#28a745',
                    boxShadow: '0 0 15px rgba(40,167,69,0.3)',
                    transition: 'all 0.3s ease',
                    minWidth: 250
                } }, { children: [_jsxs(CardContent, { children: [_jsx(Typography, __assign({ level: "h2" }, { children: "Pay-As-You-Go V1" })), _jsxs(Typography, __assign({ level: "title-lg", sx: { mb: 0.5 } }, { children: ["Variable", _jsx(Typography, __assign({ level: "title-md" }, { children: "/month" }))] })), _jsx(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 1 } }, { children: "Legacy pricing model" })), _jsx(Typography, __assign({ level: "body-xs", fontWeight: "bold", sx: { mb: 0.5 } }, { children: "Pricing:" })), _jsxs(List, __assign({ sx: { fontSize: 'xs' } }, { children: [_jsxs(ListItem, { children: ["$", ((_b = pricing === null || pricing === void 0 ? void 0 : pricing.directTransferPrice) === null || _b === void 0 ? void 0 : _b.toFixed(2)) || '0.85', " per direct transfer"] }), _jsxs(ListItem, { children: ["$", ((_c = pricing === null || pricing === void 0 ? void 0 : pricing.usedSecondPrice) === null || _c === void 0 ? void 0 : _c.toFixed(6)) || '0.001834', " per used second"] }), _jsxs(ListItem, { children: ["$", ((_d = pricing === null || pricing === void 0 ? void 0 : pricing.transferredSecondPrice) === null || _d === void 0 ? void 0 : _d.toFixed(6)) || '0.000334', " per transferred second"] }), _jsxs(ListItem, { children: ["$", ((_e = pricing === null || pricing === void 0 ? void 0 : pricing.outboundSecondPrice) === null || _e === void 0 ? void 0 : _e.toFixed(6)) || '0.002168', " per outbound second"] })] })), _jsxs(List, { children: [_jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "No monthly minimum" })] })), _jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "Cancel anytime" })] })), _jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "All features included" })] }))] })] }), _jsx(CardActions, { children: _jsx(Button, __assign({ variant: "solid", color: "success", disabled: pricing === null || pricing === void 0 ? void 0 : pricing.isPayAsYouGo, onClick: onPayAsYouGoUpgrade }, { children: (pricing === null || pricing === void 0 ? void 0 : pricing.isPayAsYouGo) ? 'Current Plan' : 'Subscribe' })) })] }))), !loadingPricing && pricingV2 && (_jsxs(Card, __assign({ variant: "outlined", sx: {
                    borderColor: '#0066ff',
                    boxShadow: '0 0 20px rgba(0,102,255,0.4)',
                    transition: 'all 0.3s ease',
                    minWidth: 250,
                    position: 'relative'
                } }, { children: [_jsx(Box, __assign({ sx: {
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            backgroundColor: '#0066ff',
                            color: 'white',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            fontWeight: 'bold'
                        } }, { children: "RECOMMENDED" })), _jsxs(CardContent, { children: [_jsx(Typography, __assign({ level: "h2" }, { children: "Pay-As-You-Go" })), _jsxs(Typography, __assign({ level: "title-lg", sx: { mb: 0.5 } }, { children: ["Variable", _jsx(Typography, __assign({ level: "title-md" }, { children: "/month" }))] })), _jsx(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 1 } }, { children: "Component-based pricing" })), _jsx(Typography, __assign({ level: "body-xs", fontWeight: "bold", sx: { mb: 0.5 } }, { children: "Base Pricing (per minute):" })), _jsxs(List, __assign({ sx: { fontSize: 'xs' } }, { children: [_jsxs(ListItem, { children: ["Base Voice Engine: $", ((_f = pricingV2 === null || pricingV2 === void 0 ? void 0 : pricingV2.baseVoiceEnginePricePerMinute) === null || _f === void 0 ? void 0 : _f.toFixed(2)) || '0.07', "/min", (pricingV2 === null || pricingV2 === void 0 ? void 0 : pricingV2.discountPercentage) > 0 && " (-".concat(pricingV2.discountPercentage, "%)")] }), _jsxs(ListItem, { children: ["Outbound Addon: $", ((_g = pricingV2 === null || pricingV2 === void 0 ? void 0 : pricingV2.outboundAddonPricePerMinute) === null || _g === void 0 ? void 0 : _g.toFixed(2)) || '0.01', "/min"] }), _jsxs(ListItem, { children: ["Direct Transfer: $", ((_h = pricingV2 === null || pricingV2 === void 0 ? void 0 : pricingV2.directTransferPrice) === null || _h === void 0 ? void 0 : _h.toFixed(2)) || '0.85'] }), _jsxs(ListItem, { children: ["Transferred: $", ((_j = pricingV2 === null || pricingV2 === void 0 ? void 0 : pricingV2.transferredSecondsPricePerMinute) === null || _j === void 0 ? void 0 : _j.toFixed(2)) || '0.04', "/min"] })] })), _jsx(Typography, __assign({ level: "body-xs", color: "neutral", sx: { mb: 0.5, fontStyle: 'italic' } }, { children: "+ STT, TTS, and LLM model pricing" })), _jsxs(List, { children: [_jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "Transparent pricing" })] })), _jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "Pay only for what you use" })] })), _jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "Detailed usage breakdown" })] })), _jsxs(ListItem, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(CheckIcon, { color: "success", sx: { mr: 1 } }), _jsx(Typography, { children: "All features included" })] }))] })] }), _jsx(CardActions, { children: _jsx(Button, __assign({ variant: "solid", color: "primary", onClick: onPayAsYouGoV2Upgrade, sx: { width: '100%' } }, { children: "Subscribe to V2" })) })] })))] })));
};
